import React, { useEffect, useState } from 'react';
import { Link, matchRoutes, useLocation } from 'react-router-dom';
import {
	Button,
	Drawer,
	IconButton,
	useMediaQuery,
	useTheme,
} from '@mui/material';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { useTranslation } from 'react-i18next';
import MenuIcon from '@mui/icons-material/Menu';
import { useSelector } from 'react-redux';
import MoreVertIcon from '@mui/icons-material/MoreVert';
// import Switch from '@mui/material/Switch';
import Brightness4Icon from '@mui/icons-material/Brightness4';
import Brightness7Icon from '@mui/icons-material/Brightness7';
import LanguageMenu from './LanguageMenu';
import UserMenu from './UserMenu';
// import Logo from '../../static/assets/logo-black.png';
import PATHS from '../../lib/consts/paths';
import CourseInfo from './CourseInfo';
import './NavigationBar.scss';
import { useAppDispatch } from '../../hooks/redux';
import { setSideBarOpen } from '../../redux/reducers/ui/sideBarReducer';
import { setIsDarkTheme } from '../../redux/reducers/ui/themeReducer';
import { RootState } from '../../redux/store';
import useUserMeQuery from '../../reactQuery/hooks/useUserMeQuery';
import Logo from '../Logo/logo';

const Navigationbar = () => {
	const dispatch = useAppDispatch();
	const { t } = useTranslation();
	const { data: currentUser } = useUserMeQuery();
	const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
	const [isCoursePage, setIsCoursePage] = useState(false);
	const { isDarkTheme } = useSelector((state: RootState) => state.ui.theme);
	const theme = useTheme();
	const currentLocation = useLocation();

	const isLandingPage = matchRoutes([{ path: '/' }], currentLocation);

	const matches = useMediaQuery('(max-width:900px)');
	const { isSideBarOpen } = useSelector((state: RootState) => state.ui.sideBar);

	const toggleMobileMenu = () => {
		setIsMobileMenuOpen(!isMobileMenuOpen);
	};
	const closeMobileMenu = () => {
		if (matches) {
			setIsMobileMenuOpen(false);
		}
	};
	const toogleSidebar = () => {
		if (isSideBarOpen) {
			dispatch(setSideBarOpen(false));
		} else {
			dispatch(setSideBarOpen(true));
		}
	};

	const toggleTheme = (value: boolean) => {
		localStorage.setItem('uiTheme', value ? 'dark' : 'light');
		dispatch(setIsDarkTheme(value));
	};

	useEffect(() => {
		if (window.location.href.includes('courses')) {
			setIsCoursePage(true);
		} else {
			setIsCoursePage(false);
		}
	}, []);

	return (
		<div
			className="Navigation"
			style={{
				backgroundColor: theme.palette.primary.contrastText,
			}}
		>
			{isCoursePage && (
				<IconButton
					className="Navigation__bar"
					onClick={toogleSidebar}
					color="secondary"
					aria-label=""
				>
					<MoreVertIcon />
				</IconButton>
			)}
			<div className="Navigation__logo">
				<Link to={currentUser ? PATHS.courses : PATHS.homePage}>
					{/* eslint-disable-next-line global-require */}
					<Logo />
				</Link>
			</div>

			<Drawer anchor="right" open={isMobileMenuOpen} onClose={closeMobileMenu}>
				<Link
					to={PATHS.courses}
					className="Navigation__main-menu__link"
					style={{ paddingTop: '20px' }}
				>
					<Button onClick={closeMobileMenu} color="primary">
						{t('home')}
					</Button>
				</Link>
				<Link to={PATHS.plans} className="Navigation__main-menu__link">
					<Button onClick={closeMobileMenu} color="primary">
						{t('pricing')}
					</Button>
				</Link>
				<Link to={PATHS.products} className="Navigation__main-menu__link">
					<Button onClick={closeMobileMenu} color="primary">
						{t('services')}
					</Button>
				</Link>
				<Link to={PATHS.contactUs} className="Navigation__main-menu__link">
					<Button onClick={closeMobileMenu} color="primary">
						{t('сontact')}
					</Button>
				</Link>
			</Drawer>

			<div className="Navigation__main-menu">
				<div>
					<CourseInfo />
				</div>
				<div>
					{/* <Switch
						checked={isDarkTheme}
						onChange={() => toggleTheme(!isDarkTheme)}
						color="secondary"
						name="themeSwitch"
						inputProps={{ 'aria-label': 'toggle theme switch' }}
					/> */}
					{!isLandingPage && (
						<IconButton
							sx={{ ml: 1 }}
							onClick={() => toggleTheme(!isDarkTheme)}
							color="primary"
						>
							{isDarkTheme ? <Brightness7Icon /> : <Brightness4Icon />}
						</IconButton>
					)}
					{isCoursePage && null && (
						<Link
							to={PATHS.codeEditorPage}
							className="Navigation__main-menu__link Navigation__main-menu__link-desktop"
							style={{
								marginRight: '17px',
								borderRight: '1px solid rgba(255,255,255,0.3)',
							}}
						>
							<Button color="primary">
								<NavigateBeforeIcon color="secondary" />
								{t('code')}
								<NavigateNextIcon color="secondary" />
							</Button>
						</Link>
					)}
					<Link
						to={PATHS.courses}
						className="Navigation__main-menu__link Navigation__main-menu__link-desktop"
					>
						<Button color="primary">{t('home')}</Button>
					</Link>
					<Link
						to={PATHS.plans}
						className="Navigation__main-menu__link Navigation__main-menu__link-desktop"
					>
						<Button color="primary">{t('pricing')}</Button>
					</Link>
					<Link
						to={PATHS.products}
						className="Navigation__main-menu__link Navigation__main-menu__link-desktop"
					>
						<Button color="primary">{t('services')}</Button>
					</Link>
					<Link
						to={PATHS.contactUs}
						className="Navigation__main-menu__link Navigation__main-menu__link-desktop"
					>
						<Button color="primary">{t('сontact')}</Button>
					</Link>
					{/* <Button href="https://codeway.today" target="_blank">
                    {t("articles")}
                </Button> */}
					<LanguageMenu hide />
					<UserMenu />
				</div>
				<IconButton
					className="Navigation__bar"
					onClick={toggleMobileMenu}
					color="secondary"
					aria-label=""
				>
					<MenuIcon />
				</IconButton>
			</div>
		</div>
	);
};
export default Navigationbar;
